/**
 * Created: 2026-09-XX
 * Initial commit: Add coach application shell
 *
 * Coach application root: router + MainWindow chrome + coach nav items.
 * Mirrors the admin app's structure (AdminApp.tsx) — starts with a single
 * placeholder home page, to be expanded with real coach features later.
 */

import SchoolIcon from '@mui/icons-material/School'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { zhCN as muiZhCN } from '@mui/x-date-pickers/locales'
import { LicenseInfo } from '@mui/x-license'
import { zhCN } from 'date-fns/locale'
import { createBrowserRouter, Navigate } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import MainWindow, { type NavItem } from '../MainWindow'
import CourseEntitlementsPage from '../pages/CourseEntitlementsPage'
import CoursesPage from '../pages/CoursesPage/CoursesPage'
import CoachHomePage from './CoachHomePage'

// register MUI-X license key, expires on Jan. 25, 2027
LicenseInfo.setLicenseKey(
  '64a59fe7cef759ee6dc51c9b876f1d97Tz0xMjM3MzgsRT0xODAwOTIxNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
)

const navItems: NavItem[] = [
  {
    group: '课程管理',
    icon: <SchoolIcon />,
    children: [
      { text: '课程发布', path: '/courses' },
      { text: '已售课时', path: '/course-entitlements' },
    ],
  },
]

function CoachMainWindow() {
  return <MainWindow navItems={navItems} />
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <CoachMainWindow />,
    children: [
      { index: true, element: <Navigate to="/home" replace /> },
      { path: 'home', element: <CoachHomePage /> },
      { path: 'courses', element: <CoursesPage /> },
      { path: 'course-entitlements', element: <CourseEntitlementsPage /> },
    ],
  },
])

export default function CoachApp() {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={zhCN}
      localeText={muiZhCN.components.MuiLocalizationProvider.defaultProps.localeText}
    >
      <RouterProvider router={router} />
    </LocalizationProvider>
  )
}
